import { PersonenTypEnum } from '../v2024';

export const PersonenTypEnumLabels = {
    NatPers: 'NatPers' as PersonenTypEnum,
    NNatPers: 'NNatPers' as PersonenTypEnum
};

